module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.image,
      "alt": _vm.alt
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1eeddeda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageLoader.vue
// module id = 97
// module chunks = 4